<template>
  <v-container fluid class="pa-6">
    <div class="d-flex justify-space-between align-center mb-1">
      <h1 class="font-weight-bold" style="font-size: 2em;">Gerenciar Fisioterapeutas</h1>
    </div>
    <v-row class="mb-6" dense>
      <v-col cols="12" md="3">
        <v-card class="pa-4" outlined>
          <div class="caption mb-1">Total</div>
          <div class="font-weight-bold" style="font-size: 2em; color: #1976d2;">
            {{ relatorio.total_fisio }}
          </div>
        </v-card>
      </v-col>
      <v-col cols="12" md="3">
        <v-card class="pa-4" outlined>
          <div class="caption mb-1">Ativos</div>
          <div class="font-weight-bold" style="font-size: 2em; color: #43a047;">
            {{ relatorio.total_fisio_ativos }}
          </div>
        </v-card>
      </v-col>
      <v-col cols="12" md="3">
        <v-card class="pa-4" outlined>
          <div class="caption mb-1">Inativos</div>
          <div class="font-weight-bold" style="font-size: 2em; color: #7c4dff;">
            {{ relatorio.total_fisio_inativos }}
          </div>
        </v-card>
      </v-col>
    </v-row>
    <v-card class="pa-4" outlined>
      <div class="font-weight-bold mb-3" style="font-size: 1.2em;">Lista de Fisioterapeutas</div>
      <v-row class="mb-4" dense>
        <v-col cols="12" md="3">
          <v-select
            v-model="filtroSelecionado"
            :items="opcoesFiltro"
            label="Buscar por"
            dense
            outlined
          ></v-select>
        </v-col>
        <v-col cols="12" md="4">
            <div>
              <v-select
                v-if="filtroSelecionado === 'ativo_fisioterapeuta'"
                v-model="valorBusca"
                :items="opcoesStatus"
                item-text="text"
                item-value="value"
                prepend-inner-icon="mdi-magnify"
                :placeholder="'Selecione status'"
                dense
                outlined
                @change="carregarFisioterapeutas"
              ></v-select>

              <v-text-field
                v-else
                v-model="valorBusca"
                prepend-inner-icon="mdi-magnify"
                :placeholder="`Digite ${filtroSelecionado.toLowerCase()}`"
                dense
                outlined
                @keyup.enter="carregarFisioterapeutas"
              ></v-text-field>
            </div>
        </v-col>
        <v-col cols="12" md="2">
          <v-btn color="primary" @click="carregarFisioterapeutas">Buscar</v-btn>
        </v-col>
      </v-row>
      <v-simple-table>
        <thead>
          <tr>
            <th>Nome</th>
            <th>Crefito</th>
            <th>Especialidade</th>
            <th>Telefone</th>
            <th>Email</th>
            <th>Atendimentos</th>
            <th>Avaliação</th>
            <th>Status</th>
            <th>Ações</th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="fisioterapeutas.length === 0">
            <td colspan="9" class="text-center grey--text">
              Nenhum fisioterapeuta encontrado
            </td>
          </tr>
          <tr v-for="(item, i) in fisioterapeutas" :key="i">
            <td><span class="font-weight-bold">{{ item.nome_completo }}</span></td>
            <td>{{ item.crefito }}</td>
            <td>
              <span v-if="item.especialidades.length">
                <span v-for="(esp, idx) in item.especialidades.slice(0,2)" :key="idx">
                  {{ esp }}<span v-if="idx < item.especialidades.slice(0,2).length - 1">, </span>
                </span>
                <span v-if="item.especialidades.length > 2">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <span v-bind="attrs" v-on="on" style="cursor:pointer; color:#1976d2;">
                        +{{ item.especialidades.length - 2 }} mais
                      </span>
                    </template>
                    <span>
                      {{ item.especialidades.slice(2).join(', ') }}
                    </span>
                  </v-tooltip>
                </span>
              </span>
              <span v-else>Não informado</span>
            </td>
            <td>{{ item.telefone }}</td>
            <td>{{ item.email }}</td>
            <td>{{ item.qtd_atendimentos }}</td>
            <td>
              <span class="font-weight-bold">{{ item.nota_fisioterapeuta }}</span>
              <v-icon color="amber" small>mdi-star</v-icon>
            </td>
            <td>
              <v-chip :color="item.statusColor" dark small>{{ item.status }}</v-chip>
            </td>
            <td>
              <v-btn icon small @click="detalhes(item)">
                <v-icon color="primary">mdi-eye</v-icon>
              </v-btn>
            </td>
          </tr>
        </tbody>
      </v-simple-table>
    </v-card>
      <v-pagination class="mt-5"
        v-model="pagina"
        :length="totalPaginas"
        @input="carregarFisioterapeutas(false)"
        show-first-last-page
        show-page-numbers
        :total-visible="9"
       />
    <v-dialog v-model="dialogDetalhes" max-width="900">
      <Detalhes
        v-if="fisioterapeutaSelecionado"
        :pessoa="fisioterapeutaSelecionado"
        @fechar="dialogDetalhes = false; carregarFisioterapeutas()"
        @success="showInfo"
        @erro="showError"
      />
    </v-dialog>
    <v-snackbar
        v-model="snackbar.active"
        :color="snackbar.color"
        :multi-line="snackbar.multiLine"
        :timeout="snackbar.timeout"
        :vertical="snackbar.vertical"
      >
        {{ snackbar.text }}
      </v-snackbar>
  </v-container>
</template>

<script>
import Detalhes from '@/components/dialogs/DetalhesPessoa.vue'
export default {
  components: {
    Detalhes
  },
  name: 'GerenciarFisioterapeutas',
  data() {
    return {
      fisioterapeutas: [],
      dialogDetalhes: false,
      fisioterapeutaSelecionado: null,
      relatorio:{total_fisio:0, 
        total_fisio_ativos:0,
        total_fisio_inativos:0,
      },
      opcoesFiltro: [
        { text: 'Nome', value: 'nome' },
        { text: 'Sobrenome', value: 'sobrenome' },
        { text: 'Email', value: 'email' },
        { text: 'Crefito', value: 'crefito' },
        { text: 'status', value: 'ativo_fisioterapeuta' }
      ],
      filtroSelecionado: 'Nome',
      valorBusca: '',
      opcoesStatus: [
        { text: 'Todos', value: null },
        { text: 'Ativo', value: true },
        { text: 'Inativo', value: false }
      ],
      itensPorPagina: 5,
      pagina: 1,
      totalItens: 0,
      snackbar: {
        active: false,
        color: '',
        multiLine: true,
        timeout: 4000,
        vertical: true,
        text: ''
      },
    }
  },
  created() {
    this.carregarFisioterapeutas()
    this.pegarRelatorio()
  },
  watch: {
    filtroSelecionado() {
      this.valorBusca = ''
    }
  },
  computed: {
    totalPaginas() {
      return Math.ceil(this.totalItens / this.itensPorPagina)
    },
    FisioterapeutasPaginados() {
      const start = (this.pagina - 1) * this.itensPorPagina;
      const end = start + this.itensPorPagina;
      return this.fisioterapeutas.slice(start, end);
    },
  },
  methods: {
    carregarFisioterapeutas(resetPage=true) {
      let campoFiltro = this.filtroSelecionado.toLowerCase()
      if (resetPage) this.pagina = 1
      const params = {
        tipo_usuario: 2,
        page: this.pagina,
        page_size: this.itensPorPagina
      }
      if (this.filtroSelecionado === 'ativo_fisioterapeuta') {
        if (this.valorBusca !== null && this.valorBusca !== '') {
          params[campoFiltro] = this.valorBusca
        }
      } else {
        if (this.valorBusca) {
          params[campoFiltro] = this.valorBusca
        }
      }
      this.$store.dispatch('pegarPessoas', params)
        .then(data => {
          const lista = Array.isArray(data) ? data : data.results || []
          this.fisioterapeutas = lista.map(json => {
            const fisio = json.fisioterapeuta || {}
            const pessoa = json
            return {
              nome_completo: pessoa.nome + ' ' + (pessoa.sobrenome || ''),
              crefito: fisio.crefito || 'Não informado',
              especialidades: Array.isArray(fisio.especialidades) ? fisio.especialidades.map(e => e.nome) : [],
              telefone: pessoa.telefone || 'Não informado',
              email: pessoa.email || 'Não informado',
              qtd_atendimentos: fisio.qtd_atendimentos || 0,
              nota_fisioterapeuta: fisio.nota_fisioterapeuta || 0,
              status: fisio.ativo ? 'Ativo' : 'Inativo',
              statusColor: fisio.ativo ? 'green' : 'red darken-2',
              objetoOriginal: json
            }
          })
          this.totalItens = data.count || this.fisioterapeutas.length
        })
        .catch(err => console.error(err))
    },
    pegarRelatorio() {
      this.$store.dispatch('pegarRelatorios')
        .then(data => {
          this.relatorio = data
        })
        .catch(err => {
          console.error('Erro ao pegar relatório:', err)
        })
    },
    detalhes(item) {
      this.fisioterapeutaSelecionado = item.objetoOriginal
      this.dialogDetalhes = true
    },
    showInfo (info) {
      this.snackbar.color = 'success'
      this.snackbar.text = info
      this.snackbar.active = true
    },
    showError (error) {
      this.snackbar.color = 'error'
      this.snackbar.text = error
      this.snackbar.active = true
    }
  }
}
</script>

<style scoped>
th, td {
  padding: 12px 8px !important;
}
.v-chip {
  font-weight: bold;
  font-size: 0.95em;
}
</style>